import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, DashboardModule,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import BrandSystemColourListItem from './BrandSystemColourListItem'

const BrandSystemColours = (props) => {
  const { brandFormPayload } = props || {}

  const {
    entityState: {
      colour_accent,
      colour_gradient_end,
      colour_gradient_start,
      colour_highlight,
      colour_primary,
      colour_secondary,
    },
  } = brandFormPayload

  const pageContext = useContext(PageContext)
  const {
    callbacks: { showManageBrandSystemColoursModal },
  } = pageContext

  const hasColours = !!(
    colour_accent
    || colour_gradient_end
    || colour_gradient_start
    || colour_highlight
    || colour_primary
    || colour_secondary
  )

  return (
    <DashboardModule title="System Brand Colours">
      <Box flexDirection="column">
        <DashboardModule.ScrollableSection>
          <BrandSystemColourListItem
            colour={colour_primary}
            text="Primary"
          />

          <BrandSystemColourListItem
            colour={colour_secondary}
            text="Secondary"
          />

          <BrandSystemColourListItem
            colour={colour_highlight}
            text="Highlight"
          />

          <BrandSystemColourListItem
            colour={colour_accent}
            text="Accent"
          />

          <BrandSystemColourListItem
            colour={colour_gradient_start}
            text="Colour Gradient Start"
          />

          <BrandSystemColourListItem
            colour={colour_gradient_end}
            text="Colour Gradient End"
          />
        </DashboardModule.ScrollableSection>

        <DashboardModule.Footer boxProps={{ borderTop: hasColours ? '1px solid' : 'none' }}>
          <DashboardModule.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => showManageBrandSystemColoursModal()}
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Manage Colours
            </Button>
          </DashboardModule.FooterRight>
        </DashboardModule.Footer>
      </Box>
    </DashboardModule>
  )
}

BrandSystemColours.propTypes = {
  brandFormPayload: PropTypes.shape({
    entityState: PropTypes.shape({
      colour_accent: PropTypes.string,
      colour_gradient_end: PropTypes.string,
      colour_gradient_start: PropTypes.string,
      colour_highlight: PropTypes.string,
      colour_primary: PropTypes.string,
      colour_secondary: PropTypes.string,
    }),
  }).isRequired,
}

export default BrandSystemColours
